import { z } from "zod";
import { MetaSchema } from "./shared";

export const CampaignUserSummaryItemSchema = z.object({
  campaignId: z.string().uuid(),
  code: z.string(),
  startDate: z.string().datetime().or(z.string()),
  endDate: z.string().datetime().or(z.string()),
  progress: z
    .object({
      totalInvested: z.number().nullable().optional(),
      bonusPreview: z.number().nullable().optional(),
      reward: z.number().nullable().optional(),
    })
    .optional()
    .nullable(),
  result: z
    .object({
      totalInvested: z.number().nullable().optional(),
      bonusPreview: z.number().nullable().optional(),
      reward: z.number().nullable().optional(),
    })
    .optional()
    .nullable(),
});

export type CampaignUserSummaryItem = z.infer<
  typeof CampaignUserSummaryItemSchema
>;

const CampaignUserSummarySchema = z.object({
  data: z.array(CampaignUserSummaryItemSchema),
  meta: MetaSchema.default,
});

export type CampaignUserSummary = z.infer<typeof CampaignUserSummaryItemSchema>;

export default CampaignUserSummarySchema;
